import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper
} from "@mui/material";
import html2canvas from "html2canvas";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { decryptAppId, decryptText } from "../../utils/encryption";

const ViewCertificate = () => {

  const dlRef1 = useRef(null);
  const dlRef2 = useRef(null);
  const dlRef3 = useRef(null);

  const [searchParams] = useSearchParams();

  const encryptedAppId = searchParams.get("appId");
  const encryptedOrgId = searchParams.get("orgId");

  const appId = encryptedAppId ? decryptAppId(encryptedAppId) : null;
  const orgIdFromUrl = encryptedOrgId ? decryptText(encryptedOrgId) : null;

  const [certificateNo, setCertificateNo] = useState("");

  // ✅ FIXED API CALL
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!appId) return;

        const response = await axios.get(
          `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetMaincertificatedata`,
          {
            params: {
              appid: appId,
              labtypeid: 3
            }
          }
        );

        setCertificateNo(response.data?.certificateNumber || "");

      } catch (error) {
        console.error("API error:", error);
      }
    };

    fetchData();
  }, [appId]);

  // Capture hidden div (download image + cert number) via html2canvas
  const handleDownload = async (ref, fileName) => {
    if (!ref.current) return;
    const canvas = await html2canvas(ref.current, { useCORS: true });
    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = fileName;
    link.click();
  };

  // ✅ Download PDF
  const handleDownloadUse = (filePath) => {
    window.open(filePath, "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: "#f5f7fa",
        py: 4,
        mt: 4
      }}
    >
      {/* Hidden off-screen download targets (download image + cert number) */}
      <div style={{ position: "fixed", left: "-9999px", top: "-9999px" }}>
        <div ref={dlRef1} style={{ display: "flex", flexDirection: "column", alignItems: "center", background: "#fff", padding: "8px" }}>
          <img src="/main/images/2.5X3.5pnewchk.png" style={{ width: "450px" }} alt="" />
          <span style={{ fontWeight: "bold", fontSize: "22px" }}>{certificateNo || "Lab Name"}</span>
        </div>
        <div ref={dlRef2} style={{ display: "flex", flexDirection: "column", alignItems: "center", background: "#fff", padding: "8px" }}>
          <img src="/main/images/2X2.25pnewcheck.png" style={{ width: "450px" }} alt="" />
          <span style={{ fontWeight: "bold", fontSize: "22px" }}>{certificateNo || "Lab Name"}</span>
        </div>
        <div ref={dlRef3} style={{ display: "flex", flexDirection: "column", alignItems: "center", background: "#fff", padding: "8px" }}>
          <img src="/main/images/3.5X4.5pnewchk.png" style={{ width: "450px" }} alt="" />
          <span style={{ fontWeight: "bold", fontSize: "22px" }}>{certificateNo || "Lab Name"}</span>
        </div>
      </div>

      <Paper sx={{ p: 4, width: 500, borderRadius: 3 }}>

        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Download NABL Symbol
        </Typography>

        {/* ✅ PDF */}
        <Box textAlign="center" mb={3}>
          <Button
            variant="contained"
            onClick={() => handleDownloadUse('/main/images/how to use symbol.pdf')}
          >
            Download How To Use Symbol
          </Button>
        </Box>

        {/* ✅ Size 1 */}
        <Box textAlign="center" mb={3}>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}} >
            <img src="/main/images/2.5X3.5.png" style={{ width: "450px" }} alt="2.5X3.5" />
            <Typography fontWeight="bold" style={{paddingLeft:'1%'}}>
              {certificateNo || "Lab Name"}
            </Typography>
          </div>

          <Button onClick={() => handleDownload(dlRef1, "2.5X3.5.png")}>
            Download 2.5 X 3.5
          </Button>
        </Box>

        {/* ✅ Size 2 */}
        <Box textAlign="center" mb={3}>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}} >
            <img src="/main/images/2X2.25.png" style={{ width: "450px" }} alt="2X2.25" />
            <Typography fontWeight="bold" style={{paddingLeft:'1%'}}>
              {certificateNo || "Lab Name"}
            </Typography>
          </div>

          <Button onClick={() => handleDownload(dlRef2, "2X2.25.png")}>
            Download 2 X 2.25
          </Button>
        </Box>

        {/* ✅ Size 3 */}
        <Box textAlign="center">
          <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}} >
            <img src="/main/images/3.5X4.5.png" style={{ width: "450px" }} alt="3.5X4.5" />
            <Typography fontWeight="bold" style={{paddingLeft:'1%'}}>
              {certificateNo || "Lab Name"}
            </Typography>
          </div>

          <Button onClick={() => handleDownload(dlRef3, "3.5X4.5.png")}>
            Download 3.5 X 4.5
          </Button>
        </Box>

      </Paper>
    </Box>
  );
};

export default ViewCertificate;
